export const filterFeatures = (features, filter) => {
    if (!filter) {
        return features;
    }

    filter = filter.toLowerCase().trim();

    const filterFeature = (feature) => {
        return feature.name?.toLowerCase()?.includes(filter) ||
            feature.description?.toLowerCase()?.includes(filter) ||
            feature.category?.toLowerCase()?.includes(filter);
    }

    return features.filter(filterFeature);
};

export const toggleValue = ({...values}, key) => {
    if (values[key]) {
        delete values[key];
    } else {
        values[key] = true;
    }
    return values;
};

export const countSelected = (selectedValues) => {
     let nSelected = 0;
     for (let key in selectedValues) {
         if (selectedValues[key]) {
             nSelected++;
         }
     }
     return nSelected;
 };

export const clip = (v, min, max) => {
    return v <= min ? min : v >= max ? max : v;
};
